import {auth, db} from '../firebase';
import {getFunctions, httpsCallable} from 'firebase/functions';
import {collection, doc, getDoc, getDocs, addDoc, setDoc, updateDoc, deleteDoc, serverTimestamp, query, orderBy} from 'firebase/firestore';
const eventsCol = collection(db, 'events');
export async function createEvent(payload = {}) {
  if (!payload.title || !payload.startAt) throw new Error('Title and start time required');
  const ref = await addDoc(eventsCol, {...payload, createdAt: serverTimestamp(), updatedAt: serverTimestamp()});
  return ref.id;
}
export async function getAllEvents() {
  const snap = await getDocs(query(eventsCol, orderBy('createdAt', 'desc')));
  return snap.docs.map(d => ({id:d.id,...d.data()}));
}
export async function getEvent(eventId) {
  const snap = await getDoc(doc(db, 'events', eventId));
  return snap.exists() ? {id:snap.id,...snap.data()} : null;
}
export async function updateEvent(eventId, patch = {}) {await updateDoc(doc(db,'events',eventId), {...patch,updatedAt:serverTimestamp()});}
export async function deleteEvent(eventId) {await deleteDoc(doc(db,'events',eventId));}
export async function rsvpToEvent({eventId, status='going', inviteCode='', fullName='', email='', phone=''}) {
  if (!eventId) throw new Error('Event ID required');
  if (status !== 'going') throw new Error('Unsupported RSVP status');
  const callable = httpsCallable(getFunctions(), 'submitEventRsvp');
  const result = await callable({eventId, inviteCode, fullName, email, phone});
  return result.data;
}
export async function checkInToEvent(eventId) {
  const user = auth.currentUser;
  if (!user) throw new Error('Sign in required to check in');
  await setDoc(doc(db,'events',eventId,'checkins',user.uid), {
    uid:user.uid,checkedAt:serverTimestamp(),method:'manual',isSundayService:false,
  }, {merge:true});
}
export async function getEventRsvps(eventId) {
  const snap = await getDocs(query(collection(db,'events',eventId,'rsvps'),orderBy('createdAt','desc')));
  return snap.docs.map(d=>({id:d.id,...d.data()}));
}
function escapeCsv(value) {
  const s = String(value ?? '');
  return /^[=+@\-\t\r]/.test(s) || /[",\n]/.test(s) ? `"${s.replace(/"/g,'""')}"` : s;
}
export function exportRsvpsToCsv(eventTitle,rsvps=[]) {
  const keys=['uid','fullName','email','phone','attendeeType','status','inviteCode','institution','createdAt'];
  const lines=[keys.join(','),...rsvps.map(r=>keys.map(k=>escapeCsv(k==='createdAt' ? (r.createdAt?.toDate?.().toISOString() || '') : (r[k] || (k==='fullName' ? r.name : '')))).join(','))];
  const blob=new Blob([lines.join('\n')],{type:'text/csv;charset=utf-8'});
  const url=URL.createObjectURL(blob); const a=document.createElement('a');a.href=url;a.download=`${eventTitle||'event'}-rsvps.csv`;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);
}
const eventsService={createEvent,getAllEvents,getEvent,updateEvent,deleteEvent,rsvpToEvent,checkInToEvent,getEventRsvps,exportRsvpsToCsv};
export default eventsService;